import MuiAccordion from "@mui/material/Accordion";
const Accordion = MuiAccordion;
export default Accordion;
